import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Tarifas from "./components/Tarifas";
import Excels from "./components/Excels";
import Steps from "./components/Steps";
import Transportistas from "./components/Transportistas";
import MensajesRecambistas from "./components/MensajesRecambistas";
import Subtipos from "./components/Subtipos";
import PlantillasEmail from "./components/PlantillasEmail";
import DescuentosMasivos from './components/DescuentosMasivos';

export default function Ajustes() {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    const [tab, setTab] = useState('mensajes');

    const handleChangeTab = (e, tab) => setTab(tab);
  
    return (
        <div className="content ajustes">
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChangeTab} aria-label="Ajustes" variant="scrollable">
                    <Tab label="Mensajes Recambistas" value="mensajes" />
                    { currentUser.rol_id === 1 ? <Tab label="Transportistas" value="transportistas" disabled={false} /> : '' }
                    <Tab label="Pasos incidéncia" value="steps" />
                    <Tab label="Subtipos incidéncia" value="subtipos" />
                    <Tab label="Plantillas email" value="plantillas_email" />
                    { currentUser.rol_id === 1 ?  <Tab label="Tarifas" value="tarifas" /> : '' }
                    { currentUser.rol_id === 1 ? <Tab label="Importación" value="importacion" disabled={false} /> : '' }
                    <Tab label="Descuentos masivos" value="descuentos_masivos" />
                </TabList>
                </Box>
                <TabPanel value="mensajes">
                    <MensajesRecambistas />
                </TabPanel>
                <TabPanel value="steps">
                    <Steps />
                </TabPanel>
                <TabPanel value="subtipos">
                    <Subtipos />
                </TabPanel>
                <TabPanel value="plantillas_email">
                    <PlantillasEmail />
                </TabPanel>
                <TabPanel value="tarifas">
                    <Tarifas />
                </TabPanel>
                <TabPanel value="transportistas">
                    <Transportistas />
                </TabPanel>
                <TabPanel value="importacion">
                    <Excels />
                </TabPanel>
                <TabPanel value="descuentos_masivos">
                    <DescuentosMasivos />
                </TabPanel>
            </TabContext>
        </div>
    )
}